import { ReactNode } from 'react'
import cx from 'classnames'

import Styles from './Badge.module.scss'

interface Props {
  children?: ReactNode
  className?: string
}

const Badge = ({ children, className }: Props) => <span className={cx(Styles.badge, className)}>{children}</span>

export default Badge
